import React from 'react';
import styled from 'styled-components';
import { BusinessSettings as BusinessSettingsInner } from './components/BusinessSettings';
import { CredentialsSettings } from '../credentials/CredentialsSettings';

const SectionDivider = styled.hr`
  color: ${({ theme }) => theme.colors.brandWhite.medium};
  margin: 24px 0 8px;
`;

export function BusinessSettingsScreen() {
  return (
    <React.Fragment>
      <BusinessSettingsInner />
      <SectionDivider />
      <CredentialsSettings />
    </React.Fragment>
  );
}
